// If we don't want to hard code these we can fetch them from an API.
// may be especially true as we change subscriptions/prices
export function getStripeProductID(
  type:
    | 'free'
    | 'pro'
    | 'more'
    | 'advanced'
    | 'unlimited'
    | 'api_standard'
    | 'individual_basic'
    | 'individual_pro'
    | 'team_standard'
    | 'team_pro'
    | 'team_scale',
) {
  // if subdomain exists grab test tokens otherwise use prod tokens
  const subdomain = window.location.hostname.replace('www.', '').split('.')[0];
  if (subdomain !== 'getcartwheel' && subdomain !== 'studio') {
    // These are test Product IDs
    switch (type) {
      // New workspace tiers (test Stripe products only for now)
      case 'individual_basic':
        return 'prod_UGMntGENbGk3pz';
      case 'individual_pro':
        return 'prod_UGMqapFDyKF5u5';
      case 'team_standard':
        return 'prod_UGMseWtUpl7q3g';
      case 'team_pro':
        return 'prod_UGMuDs4Lb3Wwm4';
      case 'team_scale':
        return 'prod_UGN0gZidDKUAtZ';

      // Interim tier API Standard monthly price
      case 'api_standard':
        return 'prod_UGNFDJpX7dsGO4';

      // Existing products (legacy tiers)
      case 'pro':
        return 'prod_OPQ1iJsg3xyXFC';
      case 'free':
        return 'prod_OPQ0y8WKSQaIyS';
      case 'more':
        return 'prod_QJR6cZX3JOkQRD';
      case 'advanced':
      case 'unlimited':
        return 'prod_SJKTimlhA1znLP';
    }
  } else {
    switch (type) {
      case 'individual_basic':
        return 'prod_UOR0ZhqMHQoyaR';
      case 'individual_pro':
        return 'prod_UOQz3OrGSVu0Aj';
      case 'team_standard':
        return 'prod_UOQzCHQV3A5R9n';
      case 'team_pro':
        return 'prod_UOQze3Vtf6ODUr';
      case 'team_scale':
        return 'prod_UOQzefgLOEbAVD';
      case 'api_standard':
        return 'prod_UGRqHMdHafCGsj';

      case 'pro':
        return 'prod_OPPy42smdkSGxv';
      case 'free':
        return 'prod_OPPw8svBGpvlgT';
      case 'more':
        return 'prod_QJR5g5xLYmu3lh';
      case 'advanced':
      case 'unlimited':
        return 'prod_SJKWHR5xdTAqzW';
    }
  }
  throw new Error(`Unhandled Stripe product type: ${String(type)}`);
}
